<div class="container">
    <mat-card appearance="outlined">
      <mat-card-title class="btn btn-rose">Edit TSI Project</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
        <form #editForm="ngForm" (ngSubmit)="saveProject()" novalidate>
          <div class="row">
            <div class="col-md-6">
              <mat-form-field color="accent">
                <mat-label>Project Name</mat-label>
                <input matInput type="text" placeholder="Project Name" name="projectName" [(ngModel)]="editProject.projectName"
                 maxlength="50" required autocomplete="off" pattern=".*\S.*">
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field color="accent"> 
                <input matInput type="text" placeholder="Description" name="description" [(ngModel)]="editProject.description" required 
                maxlength="100" autocomplete="off" pattern=".*\S.*">
              </mat-form-field>
            </div>
          </div>
        </form>
      </mat-card-content>
      <mat-card-footer>
        <div class="row action-btn justify-content-center">
            <div class="row action-btn">
                <button md-raised-button type="button" class="btn btn-rose" (click)="close()">Close</button>
                <button md-raised-button type="button" class="btn btn-rose" (click)="saveProject()"  [disabled]="!editForm.form.valid">Update</button>
            </div>
        </div>
      </mat-card-footer>
    </mat-card>
  </div>
